import { bff, createBFFHandlers } from '~/framework/bff';
import { getServerSideMonolithClient } from '~/framework';
import { getSiteInfo, SiteInfo } from '~/monolith-api';

export { getSiteInfo };

export type { SiteInfo };

export default createBFFHandlers({
   post: async (req, res) => {
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getSiteInfo({ apiClient: monolithClient });
      res.status(200).json(result);
   },
});

export const getSiteInfoFromClient = (): ReturnType<typeof getSiteInfo> => {
   return bff()
      .post('/sites/getSiteInfo')
      .then(response => response.data);
};
